// Shared cart-submission engine for all BD lens-selection modals (Klar,
// Blaulicht, Selbsttönend, Sonnenbrille). Adds the main product (optionally
// with a Sehtest file, multipart) and an optional add-on line item (a real
// Shopify variant representing the lens upgrade), paired via a "_pair"
// property so they can be matched up again in the cart.
window.BdCartEngine = (function () {
  function genPairId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 4);
  }

  async function parseCartError(res) {
    const text = await res.text();
    try {
      const json = JSON.parse(text);
      return json.description || json.message || text;
    } catch (_) {
      const match = text.match(/<title>(.*?)<\/title>/i);
      return match ? match[1] : "Unbekannter Fehler";
    }
  }

  async function addMain(mainVariantId, properties, fileInput) {
    const hasFile = fileInput && fileInput.files && fileInput.files.length;
    if (hasFile) {
      const fd = new FormData();
      fd.set("id", mainVariantId);
      fd.set("quantity", "1");
      Object.entries(properties).forEach(([k, v]) => fd.set(`properties[${k}]`, v));
      fd.set("properties[Sehtest Upload]", fileInput.files[0]);
      const res = await fetch("/cart/add", {
        method: "POST",
        body: fd,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!res.ok) throw new Error(await parseCartError(res));
    } else {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ id: parseInt(mainVariantId, 10), quantity: 1, properties }),
      });
      if (!res.ok) throw new Error(await parseCartError(res));
    }
  }

  async function addAddon(addonVariantId, pairId, mainVariantId, productTitle) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({
        id: addonVariantId,
        quantity: 1,
        properties: {
          "_pair": pairId,
          "Add-on für Variant": String(mainVariantId),
          "Add-on für Produkt": productTitle || "Brille",
        },
      }),
    });
    if (!res.ok) throw new Error(await parseCartError(res));
  }

  let isAdding = false;

  // config: { productForm, properties, fileInput, addonVariantId, onError }
  async function submit(config) {
    if (isAdding) return;
    isAdding = true;
    try {
      const mainVariantId = config.productForm.querySelector('[name="id"]')?.value;
      if (!mainVariantId) throw new Error("Kein Variant ID gefunden.");

      const props = Object.assign({}, config.properties);
      let pairId = null;
      if (config.addonVariantId) {
        pairId = genPairId();
        props["_pair"] = pairId;
      }

      await addMain(mainVariantId, props, config.fileInput);
      if (config.addonVariantId) {
        await addAddon(config.addonVariantId, pairId, mainVariantId, document.title);
      }

      window.location.href = "/cart";
    } catch (err) {
      console.error("[BdCartEngine]", err);
      if (typeof config.onError === "function") {
        config.onError(err);
      } else {
        alert("Ups – etwas hat nicht geklappt. Bitte erneut versuchen.");
      }
      isAdding = false;
    }
  }

  return { submit };
})();
